import { ICart } from "@features/cart/ICart";

export enum OrderAuthorizationEnum {
    OrderOk,
    TooMuchOffer,
    OrderImpossible,
}

export const getOrderAuthorization = (userCart: ICart | undefined) => {
    if (userCart && userCart.nbrAdditionalAllowedMobileSubscriptions <= 0) {
        const numberOfOfferCanOrder = userCart.offers.length + userCart.nbrAdditionalAllowedMobileSubscriptions;

        if (numberOfOfferCanOrder <= 0) {
            return OrderAuthorizationEnum.OrderImpossible;
        }

        return OrderAuthorizationEnum.TooMuchOffer;
    }

    return OrderAuthorizationEnum.OrderOk;
};
